// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import './fieldEditor';

/**
 * Input for fields of type link. <br/>
 * @name LinkFieldEditor
 * @constructor
 * @extends {FieldEditor}
 */
myw.LinkFieldEditor = myw.FieldEditor.extend({
    initialize(owner, feature, fieldDD, options) {
        myw.FieldEditor.prototype.initialize.call(this, owner, feature, fieldDD, options);
        this.control = new myw.Input({ value: this.fieldValue });
        this.setElement(this.control.$el);

        //enable firing 'change' event
        this.control.$el.on('input', this._changed.bind(this));
    },

    validateValue(value) {
        if (!value) return true;

        const // <description>|<url>
            regexp = /(\w+\:\/\/(.*))/i,
            res = regexp.exec(value);

        if (res) return true;
        else return this.msg('link_format');
    }
});

export default myw.LinkFieldEditor;
